import { ProvisionalContractMutation } from "@/generated/graphql_billing";
import { graphql, HttpResponse } from "msw";

// 契約を行う
export const provisionalContractMutationHandler =
  graphql.mutation<ProvisionalContractMutation>(
    "provisionalContract",
    ({ query, variables }) => {
      console.log("graphql/provisionalContract:", query, variables);
      return HttpResponse.json({
        data: {
          provisionalContract: {
            result: true,
          },
        },
      });
    }
  );
